export function querySelectorAllWatcher(
  element: HTMLElement,
  selector: string,
  callback: (node: any) => any
): {
  resultsList: Array<HTMLElement>;
  unsubscribe: () => void;
} {
  // Initialize results with current nodes.
  const result = Array.prototype.slice.call(element.querySelectorAll(selector));

  // Create observer instance.
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      Array.prototype.forEach.call(mutation.addedNodes, (node) => {
        if (node.nodeType === Node.ELEMENT_NODE && node.matches(selector)) {
          result.push(node);
          callback(node);
        }
      });
    });
  });

  // Set up observer.
  observer.observe(element, { childList: true, subtree: true });

  return {
    resultsList: result,
    unsubscribe: () => observer.disconnect(),
  };
}
